import React from 'react';
import "./SocialWidgets.css"

const FacebookFeed = () => {
    return (
        <div className="social-panel">
            <iframe
                src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FCostaCrociere&tabs=timeline&width=275&height=402&small_header=true&hide_cover=false&show_facepile=true"
                width="100%"
                height="402"
                style={{ border: 'none' }}
                allow="encrypted-media"
                title="facebook timeline"
            ></iframe>
        </div >
    );
};

export default FacebookFeed;
